// Mock data for Casaloco India - Mexican Restaurant

export const locations = [
  {
    id: 1,
    name: "Hyderabad",
    address: "2nd Floor, Radisson Hitec City, Gachibowli, Hyd - 500084",
    phone: "+91 87908 96655",
    hours: "12PM - 11PM",
    image: "https://images.unsplash.com/photo-1653084019129-1f2303bb5bc0?w=600&h=400&fit=crop",
    rating: 5,
    review: "This place is absolutely amazing! The tacos are authentic and the margaritas are perfectly balanced. The vibrant decor transports you straight to Mexico. A must-visit for Mexican food lovers in Hyderabad!",
    reviewer: "Priya S."
  }
];

export const promotions = [
  {
    id: 1,
    title: "Margarita Monday",
    description: "Buy 1 Get 1 Free on all Margaritas!",

    image: "https://images.unsplash.com/photo-1682630064338-e114ade226a2?w=400&h=400&fit=crop",
    day: "Monday"
  },
  {
    id: 2,
    title: "Taco Tuesday",
    description: "Special Taco deals all day!",
    image: "https://images.unsplash.com/photo-1707603571504-86c1ea50903e?w=400&h=400&fit=crop",
    day: "Tuesday"
  },
  {
    id: 3,
    title: "Fiesta Friday",
    description: "Exclusive discounts on all orders!",
    image: "https://images.unsplash.com/photo-1615870216519-2f9fa575fa5c?w=400&h=400&fit=crop",
    day: "Friday"
  },
  {
    id: 4,
    title: "Weekend Brunch",
    description: "Unlimited Brunch with Free-Flow Mimosas!",
    image: "https://images.unsplash.com/photo-1680364390313-9d69759de5c1?w=400&h=400&fit=crop",
    day: "Sat & Sun"
  }
];

export const menuCategories = [
  {
    id: 1,
    name: "Tacos",
    description: "Authentic Mexican tacos with various fillings",
    image: "https://images.unsplash.com/photo-1707603571504-86c1ea50903e?w=300&h=200&fit=crop"
  },
  {
    id: 2,
    name: "Burritos",
    description: "Giant burritos loaded with your favorites",
    image: "https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=300&h=200&fit=crop"
  },
  {
    id: 3,
    name: "Nachos",
    description: "Crispy nachos with melted cheese & toppings",
    image: "https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?w=300&h=200&fit=crop"
  },
  {
    id: 4,
    name: "Quesadillas",
    description: "Cheesy quesadillas with premium ingredients",
    image: "https://images.unsplash.com/photo-1618040996337-56904b7850b9?w=300&h=200&fit=crop"
  },
  {
    id: 5,
    name: "Drinks",
    description: "Margaritas, cocktails & refreshing beverages",
    image: "https://images.unsplash.com/photo-1681394420810-794f464c2e39?w=300&h=200&fit=crop"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Why Casaloco India Serves the Best Tacos in Town",
    excerpt: "Discover the secret behind our authentic Mexican tacos that keep customers coming back for more...",
    image: "https://images.unsplash.com/photo-1707604341704-74abdc25e52a?w=400&h=225&fit=crop",
    date: "July 10, 2025"
  },
  {
    id: 2,
    title: "The Perfect Margarita: A Casaloco Special",
    excerpt: "Learn about our signature margarita recipes and what makes them the talk of the town...",
    image: "https://images.unsplash.com/photo-1681394420987-1aaac01089f1?w=400&h=225&fit=crop",
    date: "July 5, 2025"
  },
  {
    id: 3,
    title: "Weekend Brunch Fiesta: Your Guide to the Best Brunch",
    excerpt: "Everything you need to know about our legendary weekend brunch with unlimited mimosas...",
    image: "https://images.unsplash.com/photo-1615870216519-2f9fa575fa5c?w=400&h=225&fit=crop",
    date: "June 28, 2025"
  }
];

export const heroImages = {
  leftFood: "https://images.unsplash.com/photo-1707603571504-86c1ea50903e?w=500&h=500&fit=crop",
  rightFood: "https://images.unsplash.com/photo-1707604341704-74abdc25e52a?w=500&h=500&fit=crop",
  drink: "https://images.unsplash.com/photo-1681394420810-794f464c2e39?w=300&h=400&fit=crop"
};
